import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/esm/Dropdown";
import { FaTrash, FaEdit, FaEye } from "react-icons/fa";
import { GoGraph } from "react-icons/go";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
import { getTasks, deleteRoadMapService } from "../../services/tasks/tasks";
import "./home.scss";
import CreateModal from "../../common-components/create-modal";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useDispatch } from 'react-redux'
import { setRoadmapBoard } from '../../store/RoadmapSlice'
function RoadMaps() {
  const [apiTasks, setApiTasks] = useState([]);
  console.log('welcom ', apiTasks)
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const dispatch = useDispatch()

  useEffect(() => {
    getAllTasks();
  }, []);
  let userId = localStorage.getItem("userId");
  const getAllTasks = () => {
    let payload = { id: userId }
    getTasks(payload).then((res) => {
      console.log("res : ", res);
      dispatch(setRoadmapBoard(res.data))
      setApiTasks(res.data);
    })
      .catch((e) => {
        console.error("err : ", e);
      });
  };

  const deleteRoadMap = (id) => {
    deleteRoadMapService(id)
      .then((res) => {
        console.log("res : ", res);
        getAllTasks();
        toast.success(res.message);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const navigate = useNavigate();

  return (
    <div>
      {
        <CreateModal
          showModal={showModal}
          setShowModal={setShowModal}
          selectedProject={selectedProject}
        />
      }
      <br />
      <div className="drop-button">
        <form className="d-flex">
          <input className="form-control me-1" type="search" placeholder="Search" aria-label="Search" onChange={(e) => setSearch(e.target.value)} />
          <button className="btn btn-outline-primary" type="submit">Search</button>
        </form>
        &nbsp;
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic" className="dropdown">
            Filter keyword
          </Dropdown.Toggle>
          <Dropdown.Menu className="D">
            <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
            <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
            <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic" className="dropdown">
            Category
          </Dropdown.Toggle>

          <Dropdown.Menu className="D">
            <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
            <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
            <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic" className="dropdown">
            Visibility
          </Dropdown.Toggle>

          <Dropdown.Menu className="D">
            <Dropdown.Item href="#/action-1">Private</Dropdown.Item>
            <Dropdown.Item href="#/action-2">Public</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic" className="dropdown">
            Personal/Team
          </Dropdown.Toggle>
          <Dropdown.Menu className="D">
            <Dropdown.Item href="#/action-2">Personal</Dropdown.Item>
            <Dropdown.Item href="#/action-3">Team</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Table......... */}
      <br></br>

      <Table striped bordered hover variant="dark">
        <thead>
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Description</th>
            <th>Author Name</th>
            <th>Author ID</th>
            <th>Board ID</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {apiTasks
            .filter((item) =>
              search.toLowerCase() == ""
                ? item
                : item.title.toLowerCase().includes(search)
            )
            // .filter((item) => item.userId === userId)
            .map((item, index) => {
              console.log("item: data", item);
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.title}</td>
                  <td>{item?.description}</td>
                  <td>{item?.userId[0]?.name}</td>
                  <td>{item?.userId[0]?._id}</td>
                  <td>{item?._id}</td>
                  <td className="actions-container">
                    <div className="hdg-label-info">
                      <FaTrash
                        onClick={() => {
                          deleteRoadMap(item._id);
                        }}
                        className="icon"
                      />
                      <div className="hdg-label-popup">
                        Delete
                      </div>
                    </div>
                    <div className="hdg-label-info">
                      <FaEye
                        onClick={() => {
                          navigate(`../roadmap/${item._id}`);
                        }}
                        className="icon"
                      />
                      <div className="hdg-label-popup">
                        View
                      </div>
                    </div>
                    <div className="hdg-label-info">
                      <FaEdit
                        className="icon"
                        onClick={() => {
                          setSelectedProject(item);
                          setShowModal(true);
                        }}
                      />
                      <div className="hdg-label-popup">
                        Edit
                      </div>
                    </div>
                    <div className="hdg-label-info">
                      <GoGraph
                        onClick={() => navigate(`/${item._id}`)}
                        className="icon"
                      />
                      <div className="hdg-label-popup">
                        Graph
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    </div>
  );
}

export default RoadMaps;
